<template>
  <div class="case-info">
    <div class="title">5.上传病历信息</div>
    <div class="hint">
      <span class="required" v-if="remindLevel === 99">*</span>
      线下就诊的历史处方、病历或报告单，只支持图片，最多可传5张
    </div>
    <div class="remind-text" v-if="remindText">
      <span class="text">
        {{ remindText }}
      </span>
    </div>
    <div class="upload-wrapper">
      <el-upload
        ref="uploader"
        class="upload"
        list-type="picture-card"
        action=""
        :limit="5"
        :multiple="false"
        accept="jpg,jpeg,png"
        :http-request="uploadFile"
        :file-list="fileList"
        :on-exceed="onExceed"
      >
        <div class="upload-selector">
          <i class="icon el-icon-plus"></i>
          <div class="text">上传照片</div>
        </div>
        <template #file="{ file }">
          <div
            class="file"
            @mouseenter="showHideDelete(file, true)"
            @mousemove="showHideDelete(file, true)"
            @mouseleave="showHideDelete(file, false)"
          >
            <img :src="file.remoteUrl" alt="" />
            <span class="el-upload-list__item-actions">
              <span class="el-upload-list__item-preview" @click="handlePictureCardPreview(file)">
                <i class="el-icon-zoom-in"></i>
              </span>
              <span class="el-upload-list__item-delete" @click="handleRemove(file)">
                <i class="el-icon-delete"></i>
              </span>
            </span>
            <el-dialog :visible.sync="dialogVisible" width="600px">
              <img width="100%" :src="dialogImageUrl" alt="" />
            </el-dialog>
          </div>
        </template>
      </el-upload>
    </div>
  </div>
</template>

<script>
import Fetch from '@/api';

export default {
  name: 'caseInfo',
  props: {
    fileList: {
      type: Array,
      default: () => []
    },
    remindText: String,
    remindLevel: Number
  },
  data() {
    return {
      disabled: false,
      handleFileId: '',
      dialogVisible: false,
      dialogImageUrl: ''
    };
  },
  methods: {
    handlePictureCardPreview(file) {
      this.dialogImageUrl = file.remoteUrl;
      this.dialogVisible = true;
    },
    handleRemove(file) {
      this.$refs.uploader.handleRemove(file);
      this.$emit('removeCaseInfo', file);
    },
    showHideDelete(file, status) {
      if (status) {
        this.handleFileId = file.uid;
        this.disabled = status;
      } else {
        this.handleFileId = '';
        this.disabled = status;
      }
    },
    onExceed() {
      this.$message.info('最多上传5张图片');
    },
    uploadFile(e) {
      const file = e.file;
      const fd = new FormData();
      fd.append(
        'uploadParam',
        JSON.stringify({ appName: 'drugstore-prescription-admin-pc', scene: 'prescription_file' })
      );
      fd.append('fileStream', file);
      Fetch.uploadImage(fd).then(res => {
        const {
          data: { url }
        } = res;

        this.$emit('addCaseInfo', { ...file, remoteUrl: url });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.case-info {
  position: relative;
  margin-bottom: 30px;

  .title {
    margin-bottom: 11px;
    color: #242424;
    font-size: 16px;
    font-weight: bold;
  }

  .hint {
    position: relative;
    margin-bottom: 23px;
    font-size: 14px;
    color: #707070;

    .required {
      font-size: 14px;
      color: #eb3c36;
    }
  }

  .remind-text {
    margin-bottom: 14px;

    .text {
      padding: 4px 12px;
      font-size: 12px;
      color: #ff8200;
      background: rgba(255, 130, 0, 0.1);
    }
  }

  .upload-wrapper {
    .upload-selector {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;

      .icon {
        margin-bottom: 13px;
        font-size: 28px;
        color: #333;
      }

      .text {
        font-size: 14px;
        color: #333;
        line-height: 1;
      }
    }

    .file {
      position: relative;
      width: 100%;
      height: 100%;
      cursor: pointer;

      img {
        width: 100%;
        height: 100%;
      }

      .remove-bar {
        position: absolute;
        left: 0;
        bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 32px;
        color: #fff;
        background-color: rgba(0, 0, 0, 0.65);
      }
    }

    .fade-enter-active,
    .fade-leave-active {
      transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to {
      opacity: 0;
    }
  }
}
</style>
